import { useState } from "react";
import { useAuthContext } from "./useAuthContext";

export const useSignup = () => {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(null);
    const { dispatch } = useAuthContext();

    const signup = async (email, password, code) => {
        setIsLoading(true);
        setError(null);

        console.log("code is in middlewear", code);

        const response = await fetch("/api/user/signup",{
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ email, password, code }),
        })
        const json = await response.json();
        console.log("successful signup response")

        if (!response.ok) {
            setError(json.error);
            setIsLoading(false);
            return;
        }
        if(response.ok){
            //save the user to local storage
            localStorage.setItem("user", JSON.stringify(json));

            //update auth context
            dispatch({type: "LOGIN", payload: json});

            setIsLoading(false);
        }
    }

    return { error, isLoading, signup };
}